import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import {
  minBreakpointQuery,
  standardColours,
  standardTransition,
  zIndexLayers,
} from '../styles';
import Logo from './Logo';
import Navigation from './Navigation';

const StyledHeader = styled.header`
  ${({ $displayNav }) => {
    if (!$displayNav) {
      return css`
        position: sticky;
        top: 0;
        right: 0;
        left: 0;
        background-color: ${standardColours.white};
        z-index: ${zIndexLayers.fourth};
      `;
    }
  }}
`;

const StyledInner = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
`;

const StyledLogo = styled(Logo)`
  display: flex;
  padding: 10px 20px;
  transition: ${standardTransition('opacity')},
    ${standardTransition('transform')};

  ${minBreakpointQuery.smedium`
    padding-right: 30px;
    padding-left: 30px;
  `}

  ${minBreakpointQuery.xxlarge`
    padding-right: 40px;
    padding-left: 40px;
  `}

  ${minBreakpointQuery.xxxxlarge`
    padding-right: 45px;
    padding-left: 45px;
  `}

  ${({ $hideLogo, $displayNav }) => {
    if ($hideLogo && !$displayNav) {
      return css`
        opacity: 0;
        transform: translateY(-100%);
      `;
    }
  }}
`;

const StyledNavigation = styled(Navigation)`
  margin-left: auto;
`;

const Header = ({ hideLogo }) => {
  const [displayNav, setDisplayNav] = useState(false);

  return (
    <StyledHeader $displayNav={displayNav}>
      <StyledInner>
        <StyledLogo $hideLogo={hideLogo} $displayNav={displayNav} />
        <StyledNavigation
          displayNav={displayNav}
          setDisplayNav={setDisplayNav}
        />
      </StyledInner>
    </StyledHeader>
  );
};

export default Header;
